import { CSSProperties, PropsWithChildren } from 'react';
import { Text, TextProps } from '../../text';

export const Title = ({
  style,
  children,
  className,
  variant = 'heading-3',
  ...textProps
}: PropsWithChildren<
  { style?: CSSProperties; className?: string } & TextProps
>) => {
  return (
    <Text variant={variant} style={style} className={className} {...textProps}>
      {children}
    </Text>
  );
};
